import { Route } from 'react-router-dom';
import Notificaciones from './Notificaciones';

const NotificacionesRouter = (
  <Route path="notificaciones">
    <Route path="" element={<Notificaciones />} />
  </Route>
);

export default NotificacionesRouter;
